// Necessary if using App Router to ensure this file runs on the client
'use client';

import { datadogRum } from '@datadog/browser-rum';
import Cookies from 'js-cookie';

import { setWebUserIdReact } from './src/Utils/commonUtils';

import packageJson from './package.json';

datadogRum.init({
  applicationId: '07efcc9b-9220-4c02-9f33-08f322871947',
  clientToken: 'pubbd5b990adf6e7929aeae84884a220772',
  site: 'us5.datadoghq.com',
  service: 'mylofamily.com',
  env: 'prod',
  // Specify a version number to identify the deployed version of your application in Datadog

  // Import version directly from package.json
  version: packageJson.version,
  sessionSampleRate: 10,
  sessionReplaySampleRate: 10,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: 'mask-user-input',
  trackBfcacheViews: true,
  // Specify URLs to propagate trace headers for connection between RUM and backend trace
  allowedTracingUrls: [
    { match: 'https://api.myloapp.in/', propagatorTypes: ['tracecontext'] },
  ],
});

// Helper function to check if user is logged in
const getUserIsLoggedIn = () => {
  return !!Cookies.get('react_user_properties') || !!Cookies.get('web_user_id_react');
};

// Helper function to get user ID from various sources
const getUserId = () => {
  // Check if user logged out but has logout user ID
  if (Cookies.get('logoutUserId') && !getUserIsLoggedIn()) {
    return Cookies.get('logoutUserId');
  }

  // Check for user properties in cookie
  if (Cookies.get('react_user_properties')) {
    return JSON.parse(Cookies.get('react_user_properties'))?.user_id;
  }

  // Fallback to web user ID
  return 'anonymous';
};
setWebUserIdReact()
const  getBrowserId = () =>{
   return Cookies.get('web_user_id_react') || null;
}
console.log('Datadog Init - User ID:', getUserId());
console.log('Datadog Init - Browser ID:', getBrowserId());
console.log('Datadog Init - Is version', packageJson.version  );
  
datadogRum.setUser({
  id:  getUserId() || 'anonymous',
  browser_id: getBrowserId() || 'anonymous',
});

datadogRum.setUserProperty('user_id', getUserId() || 'anonymous');
datadogRum.setUserProperty('browser_id', getBrowserId() || 'anonymous');

export default function DatadogInit() {
  // Render nothing - this component is only included so that the init code
  // above will run client-side
  return null;
}
